import {HttpClient} from '@esgi/api';

export class Api {
	private controllerName = 'pages/admin-home';

	init() {
		return HttpClient.default.ESGIApi.get(this.controllerName, 'init').subscribe();
	}
}
